Object.defineProperty(exports, "__esModule", { value: true });
exports.colorTokens = void 0;
/* eslint-disable import/prefer-default-export */
var natura_1 = require("./natura");
var natura_v3_1 = require("./natura_v3");
var avon_1 = require("./avon");
var avon_v2_1 = require("./avon_v2");
var theBodyShop_1 = require("./theBodyShop");
var aesop_1 = require("./aesop");
var biome_1 = require("./biome");
/**
 * @deprecated theme-bound `colorTokens` are deprecated since v0.20 and will be removed at v1.0.
 * Please use `theme.${brand}.${mode}.color` from `natds-themes`.
 */
exports.colorTokens = {
    /**
     * @deprecated `avonDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.avon.dark.color` from `natds-themes`.
     */
    avonDarkColorTokens: avon_1.avonDarkColorTokens,
    /**
     * @deprecated `avonV2DarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.avon.dark.color` from `natds-themes`.
     */
    avonV2DarkColorTokens: avon_v2_1.avonV2DarkColorTokens,
    /**
     * @deprecated `avonLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.avon.light.color` from `natds-themes`.
     */
    avonLightColorTokens: avon_1.avonLightColorTokens,
    /**
     * @deprecated `avonV2LightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.avon.light.color` from `natds-themes`.
     */
    avonV2LightColorTokens: avon_v2_1.avonV2LightColorTokens,
    /**
     * @deprecated `naturaDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.natura.dark.color` from `natds-themes`.
     */
    naturaDarkColorTokens: natura_1.naturaDarkColorTokens,
    /**
     * @deprecated `naturaLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.natura.light.color` from `natds-themes`.
     */
    naturaLightColorTokens: natura_1.naturaLightColorTokens,
    /**
     * @deprecated `naturaV3DarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.natura.light.color` from `natds-themes`.
     */
    naturaV3DarkColorTokens: natura_v3_1.naturaV3DarkColorTokens,
    /**
     * @deprecated `naturaV3LightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.natura.light.color` from `natds-themes`.
     */
    naturaV3LightColorTokens: natura_v3_1.naturaV3LightColorTokens,
    /**
     * @deprecated `theBodyShopDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.theBodyShop.dark.color` from `natds-themes`.
     */
    theBodyShopDarkColorTokens: theBodyShop_1.theBodyShopDarkColorTokens,
    /**
     * @deprecated `theBodyShopLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.theBodyShop.light.colors` from `natds-themes`.
     */
    theBodyShopLightColorTokens: theBodyShop_1.theBodyShopLightColorTokens,
    /**
     * @deprecated `aesopDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.aesop.dark.color` from `natds-themes`.
     */
    aesopDarkColorTokens: aesop_1.aesopDarkColorTokens,
    /**
     * @deprecated `aesopLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.aesop.light.colors` from `natds-themes`.
     */
    aesopLightColorTokens: aesop_1.aesopLightColorTokens,
    /**
     * @deprecated `aesopDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.aesop.dark.color` from `natds-themes`.
     */
    biomeDarkColorTokens: biome_1.biomeDarkColorTokens,
    /**
     * @deprecated `biomeLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
     * Please use `theme.biome.light.colors` from `natds-themes`.
     */
    biomeLightColorTokens: biome_1.biomeLightColorTokens
};
//# sourceMappingURL=index.js.map